import { render, staticRenderFns } from "./choosestaff.vue?vue&type=template&id=5d1eb31e&scoped=true"
import script from "./choosestaff.vue?vue&type=script&lang=js"
export * from "./choosestaff.vue?vue&type=script&lang=js"
import style0 from "./choosestaff.vue?vue&type=style&index=0&id=5d1eb31e&prod&lang=less"
import style1 from "./choosestaff.vue?vue&type=style&index=1&id=5d1eb31e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1eb31e",
  null
  
)

export default component.exports